import { render } from "./bmedit.vue?vue&type=template&id=6224ce7d&scoped=true"
import script from "./bmedit.vue?vue&type=script&lang=js"
export * from "./bmedit.vue?vue&type=script&lang=js"

import "./bmedit.vue?vue&type=style&index=0&id=6224ce7d&lang=scss&scoped=true"
import "./bmedit.vue?vue&type=style&index=1&id=6224ce7d&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6224ce7d"]])

export default __exports__